import Page from 'src/components/Page';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from 'react-router-dom';
import { Button, Container, Skeleton } from '@mui/material';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import * as constants from 'src/utils/constants';
import { showErrorToast } from 'src/utils/Toast/SnackbarProvider';
import { debounce } from 'src/utils/debounceSearch';
import { getDDMMYYYYFormat } from 'src/utils/commonUtils';
import apiInstance from 'src/utils/apiAuth';

const theme = createTheme({
    components: {
        MUIDataTable: {
            styleOverrides: {
                root: {
                    backgroundColor: '#red',
                },
                paper: {
                    boxShadow: 'none',
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    // backgroundColor: 'yellow',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    backgroundColor: 'purple',
                },
            },
        },
        MUIDataTableHeadCell: {
            styleOverrides: {
                root: {
                    fontWeight: '700',
                },
                data: {
                    fontWeight: '700',
                }
            }
        },
        MUIDataTableSelectCell: {
            styleOverrides: {
                headerCell: {
                    // backgroundColor: 'blue',
                    fontWeight: '500px'
                },
            },
        },
        MuiTableFooter: {
            styleOverrides: {
                root: {
                    '& .MuiToolbar-root': {
                        //   backgroundColor: 'purple',
                    },
                },
            },
        },
    },
    typography: {
        fontFamily: "Lexend"
    }
});

const components = {
    ExpandButton: function (props) {
        return <ExpandButton {...props} />;
    }
};

const StyledButton = {
    backgroundColor: "#00AB55",
    fontFamily: "Public Sans,sans-serif",
    fontWeight: "700",
    borderRadius: "8px",
    boxShadow: "0 8px 16px 0 rgb(0 171 85 / 10%)"
}

export default function ConfidenceLevel() {
    const [isLoading, setIsLoading] = useState(true)
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [count, setCount] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortOrder, setSortOrder] = useState();

    const debouncedSearch = debounce((query) => {
        setSearchQuery(query);
    }, 1000);

    const options = {
        selectableRows: "none",
        filter: true,
        filterType: "dropdown",
        responsive: "standard",
        download: false,
        draggableColumns: { enabled: true },
        print: false,
        page: currentPage,
        count: count,
        serverSide: true,
        rowsPerPage: rowsPerPage,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setCurrentPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setRowsPerPage(tableState.rowsPerPage);
                    break;
                case 'search':
                    debouncedSearch(tableState.searchText);
                    break;
                case 'sort':
                    setSortOrder(tableState.sortOrder);
                    break;
                default:
                    break;
            }
        },
    };

    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                filter: false,
            },
        },
        {
            name: "label",
            label: "Confidence LEvel",
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    var gid = tableMeta.rowData[0]
                    return (

                        <RouterLink
                            to={`/confidence-level/edit/${gid}`}
                            state={{ fromPage: "confidence-level" }}
                            style={{
                                textDecoration: 'none',
                                color: '#00AB55',
                                fontWeight: 'bold'
                            }}>
                            {value}
                        </RouterLink>
                    )
                }
            }
        },
        {
            name: "order",
            label: "Order",
            options: {
                filter: false,
            },
        },
        {
            name: "created",
            label: "Created On",
            options: {
                filter: false,
                customBodyRender: (value) => {
                    return (
                        <p>{getDDMMYYYYFormat(value)}</p>
                    )
                }
            }
        },
        {
            name: "modified",
            label: "Modified On",
            options: {
                filter: false,
                customBodyRender: (value) => {
                    return (
                        <p>{getDDMMYYYYFormat(value)}</p>
                    )
                }
            }
        },
        {
            name: "is_active",
            label: "Active",
            options: {
                filter: true,
                filterOptions: {
                    fullWidth: true,
                },
                customFilterListOptions: { render: v => `Is Active: ${v}` },
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value)
                        return <CheckCircleIcon fontSize='medium' color='success' />
                    else
                        return <CancelIcon fontSize='medium' color='error' />
                }
            }
        }
    ];

    const [confidenceLevelData, setConfidenceLevelData] = useState([]);
    const getConfidenceLevelData = (page, pageSize = 50, query = '', sortOrder = null) => {
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/confidence-level?`;
        if (query) apiUrl += `search=${query}&`;
        if (page + 1 && pageSize) apiUrl += `page=${page + 1}&page_size=${pageSize}&`;
        if (sortOrder && sortOrder?.name && sortOrder?.direction) apiUrl += `sortfield=${sortOrder.name}&sortdirection=${sortOrder.direction}&`

        if (apiUrl.endsWith("&")) apiUrl = apiUrl.slice(0, -1);

        apiInstance.get(apiUrl, { headers: { "Authorization": `Token ${localStorage.getItem('authToken')}` } })
            .then((response) => {
                setConfidenceLevelData(response?.data?.results?.data);
                setCount(response?.data?.count || 0);
            })
            .catch((e) => showErrorToast(e))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        getConfidenceLevelData(currentPage, rowsPerPage, searchQuery, sortOrder)
    }, [])

    return (
        <Page title="Confidence-level | CRM">
            <Container maxWidth="xl">
                <h2 align="center" style={{ fontSize: '25px', fontWeight: '800', marginBottom: '30px' }}>Confidence-level</h2>
                {isLoading ? (
                    <div style={{ padding: '16px', marginTop: "20px" }}>
                        {/* Skeleton for the Table Header */}
                        <div style={{ display: 'flex', marginBottom: '20px' }}>
                            {columns.map((column, colIndex) => (
                                <Skeleton
                                    key={colIndex}
                                    variant="text"
                                    width={'30%'}
                                    style={{ marginRight: '16px' }}
                                    height={50}
                                />
                            ))}
                        </div>
                        {/* Skeletons for the Table Rows */}
                        {Array.from(new Array(rowsPerPage)).map((_, rowIndex) => (
                            <div key={rowIndex} style={{ display: 'flex', marginBottom: '10px' }}>
                                {columns.map((column, colIndex) => (
                                    <Skeleton
                                        key={colIndex}
                                        variant="text"
                                        width={'30%'}
                                        style={{ marginRight: '16px' }}
                                        height={50}
                                    />
                                ))}
                            </div>
                        ))}
                    </div>
                ) : (
                    <ThemeProvider theme={theme}>
                        <MUIDataTable
                            title={
                                <Button
                                    variant="contained"
                                    component={RouterLink}
                                    to="/confidence-level/add/"
                                    startIcon={<Icon icon={plusFill} />}
                                    style={StyledButton}
                                >
                                    Add Confidence-level
                                </Button>
                            }
                            data={confidenceLevelData?.slice(0)?.reverse()?.map(data => {
                                return {
                                    id: data?.id,
                                    label: data?.label,
                                    order: data?.order,
                                    created: data?.created,
                                    modified: data?.modified,
                                    is_active: data?.is_active,
                                }
                            })}
                            columns={columns}
                            options={options}
                            components={components}
                        />
                    </ThemeProvider>
                )}
            </Container>
        </Page>
    )
}